import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AccountingDiary\GetAccountingDiaryByIdController::__invoke
* @see app/Http/Controllers/AccountingDiary/GetAccountingDiaryByIdController.php
* @route '/api/accounting-diary/{accounting_diary}'
*/
const GetAccountingDiaryByIdController = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAccountingDiaryByIdController.url(args, options),
    method: 'get',
})

GetAccountingDiaryByIdController.definition = {
    methods: ["get","head"],
    url: '/api/accounting-diary/{accounting_diary}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AccountingDiary\GetAccountingDiaryByIdController::__invoke
* @see app/Http/Controllers/AccountingDiary/GetAccountingDiaryByIdController.php
* @route '/api/accounting-diary/{accounting_diary}'
*/
GetAccountingDiaryByIdController.url = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { accounting_diary: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { accounting_diary: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            accounting_diary: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        accounting_diary: typeof args.accounting_diary === 'object'
        ? args.accounting_diary.id
        : args.accounting_diary,
    }

    return GetAccountingDiaryByIdController.definition.url
            .replace('{accounting_diary}', parsedArgs.accounting_diary.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountingDiary\GetAccountingDiaryByIdController::__invoke
* @see app/Http/Controllers/AccountingDiary/GetAccountingDiaryByIdController.php
* @route '/api/accounting-diary/{accounting_diary}'
*/
GetAccountingDiaryByIdController.get = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAccountingDiaryByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AccountingDiary\GetAccountingDiaryByIdController::__invoke
* @see app/Http/Controllers/AccountingDiary/GetAccountingDiaryByIdController.php
* @route '/api/accounting-diary/{accounting_diary}'
*/
GetAccountingDiaryByIdController.head = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAccountingDiaryByIdController.url(args, options),
    method: 'head',
})

export default GetAccountingDiaryByIdController